import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PublicLayout from "../shell/PublicLayout";
import Button from "../components/Button";
import { paths } from "../routing/paths";

/*
 * /unauthorized — where the admin route guards land an account without the
 * required permission. Same grammar as PermalinkPage's DesignedNotFound:
 * icon disc, plain words, a way back (admin sign-in, since every arrival
 * here came from an /admin guard) — never a blank or raw error.
 */

export default function UnauthorizedPage() {
  return (
    <PublicLayout>
      <Helmet>
        <title>No access | Inside Chassidus</title>
      </Helmet>
      <div className="max-w-[640px] w-full mx-auto px-5 py-16 flex flex-col items-center gap-4 text-center">
        <div className="w-16 h-16 rounded-full bg-ic-lightGray flex items-center justify-center">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#515F7B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="4" y="10.5" width="16" height="10" rx="2.5" />
            <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
            <circle cx="12" cy="15.5" r="1" fill="#515F7B" stroke="none" />
          </svg>
        </div>
        <h1 className="m-0 text-[28px] font-bold leading-9 tracking-[-0.3px] text-black">
          You don't have access to this page
        </h1>
        <p className="m-0 text-[18px] leading-7 text-ic-body">
          This area is for Inside Chassidus administrators. If you should have access, sign in with an
          account that has permission — or ask the site administrator to grant it.
        </p>
        <div className="flex gap-3 flex-wrap justify-center mt-2">
          <Link to="/admin">
            <Button size="lg">Go to admin sign-in</Button>
          </Link>
          <Link
            to={paths.home()}
            className="inline-flex items-center h-12 px-5 text-[16px] font-semibold text-ic-body border border-ic-borderGray rounded-3xl no-underline transition-all duration-150 ease-out hover:border-ic-blue hover:text-ic-blue hover:no-underline"
          >
            Back to the homepage
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}
